<script setup lang="ts">
import ProgramForm from '@/components/programs/ProgramForm.vue';
import CenteredContent from '@/components/content/CenteredContent.vue';
import { Selectable } from '@/components/selectBox/selectBox';

defineProps<{
  returnUrl?: string;
}>();

const form = useForm({
  method: 'POST',
  url: route('programs.store'),
  fields: {
    display_name: '',
    description: '',
    is_kpi_national_excluded: false,
    region_id: null as Selectable<number> | null,
    user_ids: [] as Selectable<number>[]
  },
  transform: (fields) => ({
    ...fields,
    region_id: fields.region_id?.value,
    user_ids: fields.user_ids?.map((user) => user.value) ?? []
  })
});
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <CenteredContent>
    <ProgramForm :form="form" :returnUrl="returnUrl" />
  </CenteredContent>
</template>
